import React from 'react';
import { TextLinkLayoutProps } from 'ui-builder';

export default function TextLinkLayout(props: TextLinkLayoutProps) {
  return (
    <a
      onClick={(event) => {
        event.preventDefault();
        event.stopPropagation();
        props.onClick?.();

        if (!props.onClick) {
          window.open(props.href, props.target || '_self');
        }
      }}
      href={props.href}
      className={props.className}
      title={props.title}
    >
      {props.children}
    </a>
  );
}
